// extracted by mini-css-extract-plugin
module.exports = {"columns":"WordChoosing_columns__LFkfx","wordChoice":"WordChoosing_wordChoice__2g7kP","checked":"WordChoosing_checked__1E3II"};